import { render, staticRenderFns } from "./SaveButtonBottom.vue?vue&type=template&id=cca47c56&"
import script from "./SaveButtonBottom.vue?vue&type=script&lang=js&"
export * from "./SaveButtonBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports